import { leSoir, leFigaro, marieClaire, trends, bilan, france24, lesEchos, laLibre } from './_assets/icons-map'

export const pressSvgs = [
  {
    index: 1,
    src: leSoir,
    alt: 'leSoir',
    width: '169',
    height: '70'
  },
  {
    index: 2,
    src: leFigaro,
    alt: 'leFigaro',
    width: '223',
    height: '70'
  },
  {
    index: 3,
    src: marieClaire,
    alt: 'marieClaire',
    width: '181',
    height: '70'
  },
  {
    index: 4,
    src: trends,
    alt: 'trends',
    width: '133',
    height: '70'
  },
  {
    index: 5,
    src: france24,
    alt: 'france24',
    width: '84',
    height: '70'
  },
  {
    index: 6,
    src: bilan,
    alt: 'bilan',
    width: '134',
    height: '70'
  },
  {
    index: 7,
    src: lesEchos,
    alt: 'lesEchos',
    width: '168',
    height: '70'
  },
  {
    index: 8,
    src: laLibre,
    alt: 'laLibre',
    width: '131',
    height: '70'
  }
]
